import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import ChesssLogo from '../images/chessslogo.png';
import { reload } from 'firebase/auth';
import constants from '../util/constants';
import { connect } from 'react-redux';

import { startGameWithAI, challengeAPlayer, createASeek } from '../util/api/lichess';
import { connectToEventStream } from '../redux/actions/gameActions';
import { usePremium } from '../util/PremiumFilter';
import LichessLogo from '../images/lichessgray.png';

import { db } from '../util/firebase';
import { collection, getDocs } from 'firebase/firestore';

// const { LICHESS_BASE_URL } = constants;
const { LICHESS_BASE_URL, LICHESS_SCOPES } = constants;

const createVerifier = (length = 43) => {
  // Generate random bytes
  const randomBytes = new Uint8Array(32);
  window.crypto.getRandomValues(randomBytes);

  // Convert to URL-safe base64 string
  const verifier = btoa(String.fromCharCode.apply(null, randomBytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  // Truncate to specified length
  return verifier.substring(0, length);
};

const createChallenge = async (verifier) => {
  // Convert verifier to Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);

  // Calculate SHA-256 hash
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);

  // Convert to URL-safe base64
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashBase64 = btoa(String.fromCharCode.apply(null, hashArray))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return hashBase64;
}

const friendsList = [
  { id: 1, username: 'Friend 1', image: 'path/to/image1.jpg' },
  { id: 2, username: 'Friend 2', image: 'path/to/image2.jpg' },
  { id: 3, username: 'Friend 3', image: 'path/to/image3.jpg' },
  { id: 4, username: 'Friend 4', image: 'path/to/image3.jpg' },
  // Add more friends as needed
];

const publicMessage = [
  { id: 1, username: 'Friend 1', message: 'this is a constant' },
  { id: 2, username: 'Friend 2', message: 'testing' },
  { id: 3, username: 'Friend 3', message: 'yo' },
  { id: 4, username: 'Friend 4', message: 'sup nerd' },
  // Add more friends as needed
];

const botProfiles = {
  'Noob': { image: ChesssLogo, rating: '400', level: 1 },
  Kittens: { image: ChesssLogo, rating: '800', level: 2 },
  'Adult Improver': { image: ChesssLogo, rating: '1200 (but getting better)', level: 3 },
  'Club Regular': { image: ChesssLogo, rating: '1600', level: 4 },
  Charlie: { image: ChesssLogo, rating: '2000', level: 5 },
  'Unrated Child': { image: ChesssLogo, rating: 'just, good luck...', level: 6 },
  Cagnus: { image: ChesssLogo, rating: '2750', level: 7 },
  Goldfish: { image: ChesssLogo, rating: '3000', level: 8 }
};

// Add this near other mock data
const onlineFriends = [
  { id: 1, username: 'pranav11111', image: ChesssLogo, rating: '1500', status: 'online' },
  { id: 2, username: 'Cronanani', image: ChesssLogo, rating: '1800', status: 'online' },
  { id: 3, username: 'pranav11', image: ChesssLogo, rating: '1800', status: 'online' },
];

const recentPlayers = [
  { id: 1, username: 'LastGame Player', image: ChesssLogo, rating: '1600', status: 'offline' },
  { id: 2, username: 'Previous Match', image: ChesssLogo, rating: '1700', status: 'online' },
  { id: 3, username: 'Previous Match2', image: ChesssLogo, rating: '1700', status: 'online' },

];

// Add user ratings based on time control categories
const userRatings = {
  bullet: 2345,  // For 1+0, 2+1
  blitz: 2123,   // For 3+0, 3+2, 5+3
  rapid: 1987    // For 10+0, 15+10
};

const getTimeControlCategory = (timeControl) => {
  if (['1+0', '2+1'].includes(timeControl)) {
    return 'bullet';
  } else if (['3+0', '3+2', '5+3'].includes(timeControl)) {
    return 'blitz';
  } else {
    return 'rapid';
  }
};

// Add user ratings for friends (you can expand this for more friends)
const friendRatings = {
  'ChessGram Desktop': {
    bullet: 1600,
    blitz: 1500,
    rapid: 1400
  },
  'Magnus Fan': {
    bullet: 2000,
    blitz: 1800,
    rapid: 1650
  }
};

// Helper function to get friend's rating based on time control
const getFriendRating = (username, timeControl) => {
  // If username is not defined, return a default rating
  if (!username) return 1500;

  const category = getTimeControlCategory(timeControl);

  // Check if this is a known friend with ratings
  if (friendRatings[username]?.[category]) {
    return friendRatings[username][category];
  }

  // For search results or unknown friends, return a default based on category
  switch (category) {
    case 'bullet':
      return 1600;
    case 'blitz':
      return 1500;
    case 'rapid':
      return 1400;
    default:
      return 1500;
  }
};

// Add common styles
const headerStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  padding: '0px 20px',
  borderRadius: '12px',
  border: '3px solid #3066be',
  fontWeight: 'bold',
  fontSize: '26px',
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '8px',
  background: 'linear-gradient(to right, #3066be, #1a4ba1)'
};

const buttonBaseStyle = {
  flex: 1,
  backgroundColor: 'transparent',
  border: '3px solid #3066be',
  fontSize: '26px',
  padding: '15px',
  borderRadius: '12px',
  cursor: 'pointer',
  fontWeight: 'bold',
  height: '70px',
  transition: 'all 0.2s ease',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const activeButtonStyle = {
  ...buttonBaseStyle,
  backgroundColor: '#3066be',
  border: '3px solid gold',
  boxShadow: '0 0 15px rgba(255, 215, 0, 0.3)',
  color: 'gold'
};

const Play = (props) => {
  const { challengeUser } = useParams();
  const [activeTab, setActiveTab] = useState('Random Opponent');
  const [selectedBot, setSelectedBot] = useState('Noob');
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [searchResults, setSearchResults] = useState({
    users: []
  });
  const [isLoading, setIsLoading] = useState(false);
  const searchInputRef = useRef(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedTimeControl, setSelectedTimeControl] = useState('3+0'); // Default to blitz
  const { renderUserWithBadge } = usePremium();
  const isConnectedToLichess = props.isConnectedToLichess;

  // Add new state for chat input
  const [chatMessage, setChatMessage] = useState('');

  // Add new state for chat messages (initialize with existing publicMessage)
  const [chatMessages, setChatMessages] = useState(publicMessage);

  // Add ref for messages container
  const messagesEndRef = useRef(null);

  // Process URL parameters and sessionStorage to set up challenge
  useEffect(() => {
    // Check URL parameters first
    const params = new URLSearchParams(window.location.search);
    const challengeParam = params.get('challenge');
    const tabParam = params.get('tab');

    // Then check sessionStorage
    const storedUsername = sessionStorage.getItem('challengeUsername');
    const openFriendsTab = sessionStorage.getItem('openFriendsTab');

    // console.log("Challenge setup:", {
    //   challengeUser,
    //   challengeParam,
    //   tabParam,
    //   storedUsername,
    //   openFriendsTab
    // });

    // Set tab to Friends if requested
    if (tabParam === 'friends' || openFriendsTab === 'true') {
      setActiveTab('Friends');
    }

    // Set selected user from any available source
    const userToChallenge = challengeUser || challengeParam || storedUsername;
    if (userToChallenge) {
      
      setSearchTerm(userToChallenge);

      // Directly set the selectedUser to the username string
      // This ensures it will be displayed correctly in the challenge button
      setSelectedUser(userToChallenge);

      // Trigger search for this user to populate results
      if (typeof handleSearch === 'function') {
        handleSearch(userToChallenge);
      }
    }

    // Clean up sessionStorage after using its values
    // This ensures they don't persist longer than needed
    sessionStorage.removeItem('challengeUsername');
    sessionStorage.removeItem('openFriendsTab');
    sessionStorage.removeItem('challengeTimestamp');

  }, [challengeUser, props.history.location]);

  // Add scroll to bottom function
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Add useEffect to scroll on new messages
  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  useEffect(() => {
    const lichesstoken = localStorage.getItem('LichessIdToken');
    const controller = new AbortController();
    if (lichesstoken && props.connectToEventStream) {
      props.connectToEventStream(controller);
    }
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (props?.game?.games?.[0]?.gameId) {
      
      props.history.push(`/PlayChess`);
    }
  }, [props.game]);

  // Get current rating based on selected time control
  const getCurrentRating = () => {
    const category = getTimeControlCategory(selectedTimeControl);
    return userRatings[category];
  };

  // Replace mock search with Firebase-based search
  const handleSearch = async (term) => {
    if (!term.trim()) {
      // If the search term is empty, don't perform a search
      // We'll show static friends/recents in the dropdown instead
      setSearchResults({
        users: []
      });
      return;
    }

    setIsLoading(true);

    try {
      // Get all users and filter client-side for case-insensitive matching
      const userSnapshot = await getDocs(collection(db, "users"));
      const userResults = [];

      // Filter the results client-side using case-insensitive matching
      userSnapshot.forEach((doc) => {
        const userData = doc.data();
        // Check if the handle field exists and contains the search term (case-insensitive)
        if (userData.handle &&
          userData.handle.toLowerCase().includes(term.toLowerCase())) {
          userResults.push({
            id: doc.id,
            name: userData.handle, // Use the original handle with its original casing
            isPremium: userData.isPremium || false,
            imageUrl: userData.imageUrl || null
          });
        }
      });

      // Limit results to prevent performance issues
      const limitedResults = userResults.slice(0, 10);

      setSearchResults({
        users: limitedResults
      });
    } catch (error) {
      console.error("Error searching users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleSearch(searchTerm);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const handleSearchBlur = () => {
    // Delay hiding results to allow for clicking on them
    setTimeout(() => {
      setIsSearchFocused(false);
    }, 200);
  };

  // Immediately show search results on focus, even if searchTerm is empty
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
  };

  const handleResultClick = (result) => {
    // Set up the user for challenge, similar to handleFriendSelect
    const category = getTimeControlCategory(selectedTimeControl);
    const defaultRating = category === 'bullet' ? 1600 : category === 'blitz' ? 1500 : 1400;

    setSelectedUser({
      id: result.id,
      username: result.name, // Add username property for consistency
      name: result.name,
      rating: defaultRating.toString(), // Assign a default rating based on time control
      image: result.imageUrl || ChesssLogo // Use user's image if available
    });
    setSearchTerm(result.name);
    setIsSearchFocused(false);
    setUserOrigin(null); // Set userOrigin to null like in handleFriendSelect
  };

  // Add state to track user origin
  const [userOrigin, setUserOrigin] = useState(null); // 'random' or null

  // Add state to check if live chat is hidden
  const [hideLiveChat] = useState(() => {
    return localStorage.getItem('hideLiveChat') === 'true';
  });

  // Common profile content styling (used in all three tabs)
  const profileContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    marginTop: '20px' // Reduced from 30px to move content up
  };

  const nameStyle = {
    color: 'white',
    fontSize: '36px', // Reduced from 42px
    margin: 0
  };

  const ratingStyle = {
    color: '#888',
    fontSize: '24px',
    margin: 0,
    marginBottom: '20px' // Added to create more space above button
  };

  // First, let's add a new function to render the current user profile
  const renderCurrentUserProfile = (timeControl, buttonText = null) => (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: '#1a1a1a',
      borderRadius: '10px',
      border: '5px solid #3066be',
      position: 'relative',
      height: '210px', // Match bot profile height
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '20px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '3px solid #3066be'
        }}>
          <img
            src={ChesssLogo}
            alt="Your profile"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div>
          <h2 style={{
            color: 'white',
            fontSize: '30px',
            marginBottom: '5px'
          }}>
            {renderUserWithBadge(props.user.credentials ? props.user.credentials.handle : 'Loading...')}
          </h2>
          <p style={{
            color: '#888',
            fontSize: '18px'
          }}>
            {getCurrentRating()} ({getTimeControlLabel(timeControl)})
          </p>
        </div>
      </div>

      {buttonText && (
        <button
          className="butonejzis-3"
          style={{
            backgroundColor: '#ff0050',
            color: 'black',
            padding: '15px',
            border: '5px solid gold',
            borderRadius: '10px',
            cursor: 'pointer',
            fontSize: '30px',
            width: '100%',
            fontWeight: 'bold',
            height: '220px',
            marginTop: '20px',
            position: 'absolute',
            bottom: '-110px',
            left: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {buttonText}
        </button>
      )}
    </div>
  );

  // Update handleTabChange to reset friend selection when switching to Friends tab
  const handleTabChange = (tab) => {
    if (userOrigin === 'random' && selectedUser) {
      // Clear random user state when switching tabs
      setSelectedUser(null);
      setUserOrigin(null);
    }

    if (tab === 'Random Opponent') {
      setIsChatVisible(false); // Collapse chat when switching to Random tab
    }

    if (tab === 'Friends') {
      // Check if we have a challenge username stored
      const challengeUsername = sessionStorage.getItem('challengeUsername');
      const urlParams = new URLSearchParams(window.location.search);
      const challengeParam = urlParams.get('challenge');

      // If we have a challenge username and no currently selected user,
      // we should preserve the challenge setup
      if ((challengeUsername || challengeParam || props.match?.params?.challengeUser) && !selectedUser) {
        const userToChallenge = props.match?.params?.challengeUser || challengeParam || challengeUsername;
        

        setSearchTerm(userToChallenge);
        // Directly set the selectedUser to the username string to ensure it's displayed properly
        setSelectedUser(userToChallenge);

        // Trigger search for this user to populate results
        if (typeof handleSearch === 'function') {
          handleSearch(userToChallenge);
        }
      } else {
        // Standard behavior - reset friend selection state 
        if (!selectedUser) {
          setSearchTerm('');
          setSearchResults({
            users: []
          });
        }
      }

      setIsSearchFocused(false);
    }

    setActiveTab(tab);
  };

  // Update handleViewFromChat to ensure we stay in Random tab
  const handleViewFromChat = (username) => {
    const user = chatMessages.find(msg => msg.username === username);

    if (user) {
      setSelectedUser({
        username: user.username,
        name: user.username,
        rating: user.rating || '1500',
        image: user.image || ChesssLogo
      });
      setUserOrigin('random');
      // No need to change activeTab here
    }
  };

  // Modify handleReturn handler to not change tabs for random origin
  const handleReturn = () => {
    if (userOrigin === 'random') {
      // Only reset the user and origin, don't change tab
      setSelectedUser(null);
      setUserOrigin(null);
    } else {
      // Standard return to Friends tab for non-random origins
      setSelectedUser(null);
      setSearchTerm('');
    }
  };

  // Update the friend selection handler to include dynamic rating
  const handleFriendSelect = (friend) => {
    setSelectedUser({
      username: friend.username,
      name: friend.username,
      rating: getFriendRating(friend.username, selectedTimeControl),
      image: friend.image
    });
    setUserOrigin(null);
  };

  // Add new state for reply
  const [replyingTo, setReplyingTo] = useState(null);

  // Add handler for starting a reply
  const handleStartReply = (messageId, username, message) => {
    setReplyingTo({
      id: messageId,
      username: username,
      message: message
    });
  };

  // Modify chat submit to handle replies
  const handleChatSubmit = (e) => {
    e.preventDefault();
    if (chatMessage.trim()) {
      const newMessage = {
        id: chatMessages.length + 1,
        username: 'You',
        message: chatMessage,
        replyTo: replyingTo // Include reply information if present
      };
      setChatMessages([...chatMessages, newMessage]);
      setChatMessage('');
      setReplyingTo(null); // Clear reply state after sending
    }
  };

  // Add handler for clicking on reply reference
  const handleReplyClick = (replyId) => {
    // Find the referenced message
    const referencedMessage = chatMessages.find(msg => msg.id === replyId);
    if (referencedMessage) {
      // Scroll to the referenced message
      const messageElement = document.getElementById(`chat-message-${replyId}`);
      messageElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Optional: Add highlight effect
      messageElement?.classList.add('highlight');
      setTimeout(() => messageElement?.classList.remove('highlight'), 2000);
    }
  };

  // Add state for chat visibility
  const [isChatVisible, setIsChatVisible] = useState(false);

  // Add handler for toggling chat
  const toggleChat = () => {
    setIsChatVisible(!isChatVisible);
    if (!isChatVisible) {
      // Clear reply state when opening chat
      setReplyingTo(null);
    }
  };

  const onClickStartGameWithAI = async () => {
    const level = botProfiles[selectedBot].level;
    const response = await startGameWithAI(level, 300, 0);
    props.history.push('/playchess');
  };

  const handleChallengeAPlayer = async (username) => {
    const [base, incrementInSeconds] = selectedTimeControl.split("+");
    const baseInSeconds = base * 60;
    const response = await challengeAPlayer(username, baseInSeconds, Number(incrementInSeconds));
    props.history.push('/playchess');
  };

  const onClickStartRandomGame = async () => {
    const [baseInMinutes, incrementInSeconds] = selectedTimeControl.split("+");
    const response = await createASeek(Number(baseInMinutes), Number(incrementInSeconds));
    props.history.push('/playchess');
  }

  // Add helper function to get time control category label
  const getTimeControlLabel = (timeControl) => {
    const category = getTimeControlCategory(timeControl);
    switch (category) {
      case 'bullet':
        return 'Bullet';
      case 'blitz':
        return 'Blitz';
      case 'rapid':
        return 'Rapid';
      default:
        return 'Standard';
    }
  };

  const renderTimeControls = () => {
    if (activeTab === 'Bot') {
      return (
        <div className="time-controls-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '15px',
          marginTop: '15px'
        }}>
          {Object.keys(botProfiles).map(botName => (
            <button
              key={botName}
              className={`butonejzis-3 ${selectedBot === botName ? 'active' : ''}`}
              onClick={() => setSelectedBot(botName)}
              style={{
                backgroundColor: selectedBot === botName ? '#3066be' : 'transparent',
                color: selectedBot === botName ? 'gold' : 'white',
                border: `5px solid ${selectedBot === botName ? 'gold' : '#3066be'}`,
                borderRadius: '12px',
                padding: '20px 15px',
                fontSize: '24px',
                width: '100%',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {botName}
            </button>
          ))}
        </div>
      );
    }

    // Time controls for Friend and Random modes
    const timeControls = ['1+0', '2+1', '3+0', '3+2', '5+3', '10+0', '15+10'];

    return (
      <div className="time-controls-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '15px',
        marginTop: '15px'
      }}>
        {timeControls.map(control => (
          <button
            key={control}
            onClick={() => setSelectedTimeControl(control)}
            className="butonejzis-3"
            style={{
              backgroundColor: selectedTimeControl === control ? '#3066be' : 'transparent',
              color: selectedTimeControl === control ? 'gold' : 'white',
              border: `5px solid ${selectedTimeControl === control ? 'gold' : '#3066be'}`,
              borderRadius: '12px',
              padding: '20px 15px',
              fontSize: '24px',
              width: '100%',
              height: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {control}
          </button>
        ))}

        {/* Last button changes based on tab */}
        {activeTab === 'Random Opponent' ? (
          <button
            className="butonejzis-3"
            style={{
              backgroundColor: 'transparent',
              color: 'gray',
              border: '5px solid gray',
              borderRadius: '12px',
              padding: '20px 15px',
              fontSize: '24px',
              width: '100%',
              height: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            Have Fun !
          </button>
        ) : (
          <button
            className="butonejzis-3"
            style={{
              backgroundColor: 'transparent',
              color: 'gray',
              border: '5px solid gray',
              borderRadius: '12px',
              padding: '20px 15px',
              fontSize: '24px',
              width: '100%',
              height: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              hover: 'none'
            }}
          >
            <input
              type="checkbox"
              defaultChecked={true}
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer'
              }}
            />
            Rated
          </button>
        )}
      </div>
    );
  };

  const renderFriendsAndRecents = (list) => (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: '100%'
    }}>
      {list.map(item => (
        <div
          key={item.id}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
            backgroundColor: '#1a1a1a',
            borderRadius: '8px',
            width: '100%',
            boxSizing: 'border-box',
            border: '3px solid #3066be'
          }}
        >
          <div style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            overflow: 'hidden',
            marginRight: '15px',
            border: '2px solid #3066be'
          }}>
            <img
              src={item.image}
              alt={item.username}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div style={{ flexGrow: 1, textAlign: 'left' }}>
            <div style={{ color: 'white', fontSize: '20px', marginBottom: '4px' }}>
              {item.username}
            </div>
            <div style={{ color: '#888', fontSize: '16px' }}>
              Overall Rating: <span style={{ color: '#888' }}>{item.rating}</span>
            </div>
          </div>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: '#ff0050',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              marginLeft: 'auto',
              fontSize: '16px'
            }}
            onClick={() => handleFriendSelect(item)}
          >
            Challenge
          </button>
        </div>
      ))}
    </div>
  );

  const renderBotProfile = () => (
    <div className="bot-profile" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px',
      position: 'relative',
      height: '310px',
      backgroundColor: '#1a1a1a',
      borderRadius: '10px',
      border: '5px solid #3066be',
    }}>
      <div style={profileContentStyle}>
        {/* Profile Image */}
        <div style={{
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '3px solid #3066be'
        }}>
          <img
            src={botProfiles[selectedBot].image}
            alt={`${selectedBot} bot`}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>

        {/* Bot Name and Rating */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '5px'
        }}>
          <h2 style={nameStyle}>{selectedBot}</h2>
          <p style={ratingStyle}>
            Rating: {botProfiles[selectedBot].rating}
          </p>
        </div>
      </div>

      {/* Challenge Button */}
      <button
        className="butonejzis-3"
        style={{
          backgroundColor: '#ff0050',
          color: 'black',
          padding: '15px',
          border: '5px solid gold',
          borderRadius: '10px',
          cursor: 'pointer',
          fontSize: '30px',
          width: '80%',
          fontWeight: 'bold',
          height: '150px',
          position: 'absolute',
          bottom: '-100px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '15px'
        }}
        onClick={onClickStartGameWithAI}
      >
        <i className="fa-solid fa-chess-board"></i>
        Play vs. {selectedBot}
      </button>
    </div>
  );

  // Update renderPublicContent to use the new style
  const renderPublicContent = () => (
    <div className="tab-content" style={{
      display: 'flex',
      gap: '20px',
      width: '100%'
    }}>
      <div className="left-panel" style={{
        flex: 1,
        minWidth: '300px'
      }}>
        <div style={headerStyle}>Time Control:</div>
        {renderTimeControls()}
      </div>

      <div className="right-panel" style={{
        flex: 1,
        minWidth: '300px'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
          position: 'relative',
          height: '310px',
          backgroundColor: '#1a1a1a',
          borderRadius: '10px',
          border: '5px solid #3066be',
        }}>
          <div style={profileContentStyle}>
            <div style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: '3px solid #3066be'
            }}>
              <img
                src={ChesssLogo}
                alt="Your profile"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px'
            }}>
              <h2 style={nameStyle}>{renderUserWithBadge(props.user.credentials ? props.user.credentials.handle : 'Loading...')}
              </h2>
              <p style={ratingStyle}>
                {getTimeControlLabel(selectedTimeControl)} | {getCurrentRating()}
              </p>
            </div>
          </div>

          <button
            className="butonejzis-3"
            onClick={onClickStartRandomGame}
            style={{
              backgroundColor: '#ff0050',
              color: 'black',
              padding: '15px',
              border: '5px solid gold',
              borderRadius: '10px',
              cursor: 'pointer',
              fontSize: '30px',
              width: '80%',
              fontWeight: 'bold',
              height: '150px',
              position: 'absolute',
              bottom: '-100px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px'
            }}
          >
            <i className="fa-solid fa-chess-board"></i>
            Play vs. Random
          </button>
        </div>
      </div>
    </div>
  );

  // Add this new function to generate the search results display
  const searchResultsDisplay = () => (
    <div style={{
      position: 'absolute',
      top: '100%',
      width: '100%', // This is 100% of the parent container (which is now 50% of the page)
      backgroundColor: '#222',
      borderRadius: '0 0 10px 10px',
      zIndex: 10,
      maxHeight: '400px', // Increased to fit more content
      overflowY: 'auto',
      boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
      marginTop: '3px'
    }}>
      {isLoading ? (
        <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
          Searching...
        </div>
      ) : (
        <>
          {/* Show search results if available */}
          {searchResults.users && searchResults.users.length > 0 && searchTerm.trim() !== "" ? (
            <div style={{ width: '100%' }}>
              <div style={{
                padding: '10px',
                backgroundColor: '#333',
                color: '#aaa',
                fontSize: '18px',
                display: 'grid',
                gridTemplateColumns: '40% 20% 20% 20%',
                alignItems: 'center',
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                <div style={{ textAlign: 'left' }}>
                  <i className="fa-solid fa-user" style={{ marginRight: '5px', color: '#888' }}></i>SEARCH RESULTS
                </div>
                <div>BULLET</div>
                <div>BLITZ</div>
                <div>RAPID</div>
              </div>
              {searchResults.users.map(user => (
                <div
                  key={user.id}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #333',
                    display: 'grid',
                    gridTemplateColumns: '40% 20% 20% 20%',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                  onClick={() => handleResultClick(user)}
                >
                  <div style={{ color: 'white', textAlign: 'left', fontSize: '20px', fontWeight: 'bold' }}>
                    {renderUserWithBadge(user.name)}
                  </div>
                  <div style={{ color: '#f89e31' }}>
                    {getFriendRating(user.name, '1+0')}
                  </div>
                  <div style={{ color: '#4caf50' }}>
                    {getFriendRating(user.name, '3+0')}
                  </div>
                  <div style={{ color: '#3066be' }}>
                    {getFriendRating(user.name, '10+0')}
                  </div>
                </div>
              ))}
            </div>
          ) : searchTerm.trim() === "" ? (
            // Show friends and recents when search is empty
            <>
              {/* Friends section */}
              <div style={{ width: '100%' }}>
                <div style={{
                  padding: '10px',
                  backgroundColor: '#333',
                  color: '#aaa',
                  fontSize: '18px',
                  display: 'grid',
                  gridTemplateColumns: '40% 20% 20% 20%',
                  alignItems: 'center',
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}>
                  <div style={{ textAlign: 'left' }}>
                    <i class="fa-solid fa-user-group" style={{ marginRight: '5px', color: '#888' }}></i>FRIENDS
                  </div>
                  <div>BULLET</div>
                  <div>BLITZ</div>
                  <div>RAPID</div>
                </div>
                {onlineFriends.map(friend => (
                  <div
                    key={friend.id}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #333',
                      display: 'grid',
                      gridTemplateColumns: '40% 20% 20% 20%',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                    onClick={() => handleFriendSelect(friend)}
                  >
                    <div style={{ color: 'white', textAlign: 'left', fontSize: '20px', fontWeight: 'bold' }}>
                      {friend.username}
                    </div>
                    <div style={{ color: '#f89e31' }}>
                      {getFriendRating(friend.username, '1+0')}
                    </div>
                    <div style={{ color: '#4caf50' }}>
                      {getFriendRating(friend.username, '3+0')}
                    </div>
                    <div style={{ color: '#3066be' }}>
                      {getFriendRating(friend.username, '10+0')}
                    </div>
                  </div>
                ))}
              </div>

              {/* Recents section */}
              <div style={{ width: '100%', marginTop: '10px' }}>
                <div style={{
                  padding: '10px',
                  backgroundColor: '#333',
                  color: '#aaa',
                  fontSize: '18px',
                  display: 'grid',
                  gridTemplateColumns: '40% 20% 20% 20%',
                  alignItems: 'center',
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}>
                  <div style={{ textAlign: 'left' }}>
                    <i className="fa-solid fa-clock-rotate-left" style={{ marginRight: '5px', color: '#888' }}></i>RECENTS
                  </div>
                  <div>BULLET</div>
                  <div>BLITZ</div>
                  <div>RAPID</div>
                </div>
                {recentPlayers.map(player => (
                  <div
                    key={player.id}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #333',
                      display: 'grid',
                      gridTemplateColumns: '40% 20% 20% 20%',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                    onClick={() => handleFriendSelect(player)}
                  >
                    <div style={{ color: 'white', textAlign: 'left', fontSize: '20px', fontWeight: 'bold' }}>
                      {player.username}
                    </div>
                    <div style={{ color: '#f89e31' }}>
                      {getFriendRating(player.username, '1+0')}
                    </div>
                    <div style={{ color: '#4caf50' }}>
                      {getFriendRating(player.username, '3+0')}
                    </div>
                    <div style={{ color: '#3066be' }}>
                      {getFriendRating(player.username, '10+0')}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
              No results found for "{searchTerm}"
            </div>
          )}
        </>
      )}
    </div>
  );

  const renderFriendsContent = () => (
    <div className="tab-content" style={{
      display: 'flex',
      gap: '20px',
      width: '100%',
    }}>
      {!selectedUser ? (
        <div className="friends-search" style={{
          width: '100%',
          margin: '0 auto',
          padding: '5px',
          height: '445px', // Changed from fixed height to auto
        }}>
          <div style={{ fontSize: '30px', color: 'gold', marginBottom: '20px', fontWeight: 'bold', textAlign: 'center' }}>
            Search For Any User . . .
          </div>
          {/* Search input with updated width */}
          <div className="search-section" style={{
            width: '50%',
            margin: '0 auto',
            marginBottom: '20px',
            position: 'relative'
          }}>
            <div style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}>
              <input
                ref={searchInputRef}
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={handleSearchFocus}
                onBlur={handleSearchBlur}
                placeholder="Start Typing . . ."
                style={{
                  width: '100%',
                  padding: '20px',
                  paddingRight: '40px',
                  border: '5px solid gold',
                  borderRadius: '5px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  fontSize: '20px',
                  outline: 'none'
                }}
              />
              <i
                className="fa-solid fa-magnifying-glass"
                style={{
                  position: 'absolute',
                  right: '12px',
                  color: 'gold',
                  fontSize: '18px',
                  pointerEvents: 'none'
                }}
              />
            </div>
            {isSearchFocused && searchResultsDisplay()}
          </div>
        </div>
      ) : (
        <>
          <div className="left-panel" style={{
            flex: 1,
            minWidth: '300px'
          }}>
            <div style={headerStyle}>Time Control:</div>
            {renderTimeControls()}
          </div>

          <div className="right-panel" style={{
            flex: 1,
            minWidth: '300px'
          }}>
            {renderSelectedUserProfile()}
          </div>
        </>
      )}
    </div>
  );

  const renderEngineContent = () => (
    <div className="tab-content" style={{
      display: 'flex',
      gap: '20px',
      width: '100%'
    }}>
      <div className="left-panel" style={{
        flex: 1,
        minWidth: '300px'
      }}>
        <div style={headerStyle}>Bot Strength:</div>
        {renderTimeControls()}
      </div>

      <div className="right-panel" style={{
        flex: 1,
        minWidth: '300px'
      }}>
        {renderBotProfile()}
      </div>
    </div>
  );

  // Update renderSelectedUserProfile for the Friends tab
  const renderSelectedUserProfile = () => (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px',
      position: 'relative',
      height: '310px',
      backgroundColor: '#1a1a1a',
      borderRadius: '10px',
      border: '5px solid #3066be',
    }}>
      {/* X button */}
      <button
        onClick={handleReturn}
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          backgroundColor: 'transparent',
          border: '2px solid #ff0050',
          borderRadius: '5px',
          color: '#ff0050',
          padding: '8px 15px',
          cursor: 'pointer',
          fontSize: '24px'
        }}
      >
        <i className="fa-solid fa-circle-xmark"></i>
      </button>

      <div style={profileContentStyle}>
        <div style={{
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '3px solid #3066be'
        }}>
          <img
            src={ChesssLogo}
            alt="Your profile"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '5px'
        }}>
          <h2 style={nameStyle}>{renderUserWithBadge(props.user.credentials ? props.user.credentials.handle : 'Loading...')}</h2>
          <p style={ratingStyle}>
            {getTimeControlLabel(selectedTimeControl)} | {getCurrentRating()}
          </p>
        </div>
      </div>

      <button
        className="butonejzis-3"
        onClick={() => handleChallengeAPlayer(typeof selectedUser === 'string' ? selectedUser : (selectedUser.username || selectedUser.name))}
        style={{
          backgroundColor: '#ff0050',
          color: 'black',
          padding: '15px',
          border: '5px solid gold',
          borderRadius: '10px',
          cursor: 'pointer',
          width: '80%',
          fontWeight: 'bold',
          height: '150px',
          position: 'absolute',
          bottom: '-100px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '15px'
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          width: '100%',
          padding: '0 20px'
        }}>
          <img
            src={typeof selectedUser === 'object' && selectedUser.image ? selectedUser.image : ChesssLogo}
            alt={typeof selectedUser === 'string' ? selectedUser : (selectedUser.username || selectedUser.name || 'Opponent')}
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              border: '3px solid gold'
            }}
          />
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{
                fontSize: '28px',
                fontWeight: 'bold',
                marginRight: '8px',
                color: 'black'
              }}>
                {typeof selectedUser === 'string' ? selectedUser : (selectedUser.username || selectedUser.name || 'Opponent')}
              </span>
              <span style={{
                fontSize: '16px',
                color: 'white',
                backgroundColor: 'rgba(0,0,0,0.3)',
                padding: '2px 8px',
                borderRadius: '4px'
              }}>
                {getFriendRating(typeof selectedUser === 'string' ? selectedUser : (selectedUser.username || selectedUser.name), selectedTimeControl)}
              </span>
            </div>

            <div style={{
              fontSize: '30px',
              marginTop: '5px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }} onClick={() => handleChallengeAPlayer(selectedUser.username || selectedUser.name)}>
              <i className="fa-solid fa-chess-board"></i>&nbsp;&nbsp;
              Send Challenge
            </div>
          </div>
        </div>
      </button>
    </div>
  );

  const redirectToLichessLogin = async () => {
    const verifier = createVerifier()
    const challenge = await createChallenge(verifier)
    const redirectUrl = `${window.location.origin}/oauth/callback`
    localStorage.setItem('lichessOauthConfig', JSON.stringify({
      verifier,
      redirectUrl,
    }));

    const url = `${LICHESS_BASE_URL}/oauth?` + new URLSearchParams({
      response_type: 'code',
      client_id: 'chess-app',
      redirect_uri: redirectUrl,
      code_challenge_method: 'S256',
      code_challenge: challenge,
      scope: LICHESS_SCOPES.join(" "),
    });

    window.open(url, '_blank');

    // check if user is connected to lichess
    const x = setInterval(() => {
      const isConnectedToLichess = localStorage.getItem('LichessIdToken') !== null;
      if (isConnectedToLichess) {
        window.location.reload();
      }
    }, [1000]);
    setTimeout(() => {
      clearInterval(x);
    }, 10000);
  }

  if (!isConnectedToLichess) {
    return (
      <div className="app-container">
        <div className="explore-container main-column" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '25px 20px',
          scrollbarColor: '#ff0050 transparent',
          maxWidth: '1200px',
          background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
        }}>
          {/* Title Section */}
          <div style={{
            border: "5px solid #58b047",
            color: "#58b047",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '15px 25px',
            flexDirection: 'column',
            fontSize: "40px",
            fontWeight: "bold",
            background: "rgba(48, 102, 190, 0.4)",
            width: '100%',
            maxWidth: '800px',
            marginBottom: '30px',
            borderRadius: "8px",
            boxShadow: "0 0 30px rgba(0,0,0,0.5)"
          }}>
            Play Chess on LiChess
          </div>

          {/* Two column content */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: '1000px',
            gap: '30px',
            marginBottom: '20px',
            flexWrap: 'wrap'
          }}>
            {/* Left Column - Seamless Gameplay */}
            <div style={{
              flex: '1 1 300px',
              background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
              borderRadius: "12px",
              padding: "20px 30px",
              boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
              border: "1px solid rgba(255,215,0,0.5)",
            }}>
              <h2 style={{
                fontSize: "28px",
                marginBottom: "20px",
                color: "gold",
                fontWeight: "bold",
                borderBottom: "2px solid gold",
                paddingBottom: "10px",
                textAlign: "center"
              }}>
                Seamless Gameplay
              </h2>
              <ul style={{
                listStyleType: 'disc',
                paddingLeft: '30px',
                lineHeight: '1.8',
                color: 'white',
                fontSize: '18px',
              }}>
                <li style={{ marginBottom: '15px' }}>Fast and reliable chess against a global community of players.</li>
                <li style={{ marginBottom: '15px' }}>Available 24/7, for any skill level.</li>
                <li style={{ marginBottom: '15px' }}>Free PvP chess gameplay for all!</li>
              </ul>
            </div>

            {/* Right Column - How it Works */}
            <div style={{
              flex: '1 1 300px',
              background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
              borderRadius: "12px",
              padding: "20px 30px",
              boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
              border: "1px solid rgba(255,215,0,0.5)",
            }}>
              <h2 style={{
                fontSize: "28px",
                marginBottom: "20px",
                color: "gold",
                fontWeight: "bold",
                borderBottom: "2px solid gold",
                paddingBottom: "10px",
                textAlign: "center"
              }}>
                How it Works
              </h2>
              <ul style={{
                listStyleType: 'disc',
                paddingLeft: '30px',
                lineHeight: '1.8',
                color: 'white',
                fontSize: '18px',
              }}>
                <li style={{ marginBottom: '15px' }}>Securely connect your Lichess account.</li>
                <li style={{ marginBottom: '15px' }}>We only access your public Lichess info to enhance your experience.</li>
                <li style={{ marginBottom: '15px' }}>You may have to log in again after a while.</li>
              </ul>
            </div>
          </div>

          {/* Connect button with improved design - PROMINENT CALL TO ACTION */}
          <div style={{
            width: '100%',
            maxWidth: '800px',
            marginBottom: '40px',
            position: 'relative',
            padding: '10px',
            background: 'rgba(0,0,0,0.3)',
            borderRadius: '16px',
          }}>

            {/* Connect button */}
            <button
              onClick={redirectToLichessLogin}
              style={{
                width: '100%',
                maxWidth: '800px',
                height: 'clamp(80px, 10vw, 120px)',
                backgroundColor: '#ff0050',
                color: 'gold',
                fontSize: 'clamp(24px, 3vw, 36px)',
                fontWeight: 'bold',
                borderRadius: '5px',
                border: '5px solid gold',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 8px 30px rgba(255, 0, 80, 0.5), 0 0 30px rgba(255, 215, 0, 0.4)',
                transform: 'translateY(0)',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(255, 0, 80, 0.7), 0 0 40px rgba(255, 215, 0, 0.6)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(255, 0, 80, 0.5), 0 0 30px rgba(255, 215, 0, 0.4)';
              }}
            >
              Connect to Lichess
            </button>

            {/* Arrow indicator - ONLY SHOWN ONCE */}
            <div style={{
              position: 'absolute',
              bottom: '-55px',
              left: '50%',
              transform: 'translateX(-50%)',
              color: 'gold',
              fontSize: '28px',
              fontWeight: 'bold',
            }}>
              ↑ Click to Start Playing ↑
            </div>
          </div>

          {/* FAQ reference */}
          <div style={{
            color: 'white',
            fontSize: '18px',
            textAlign: 'center',
            marginBottom: '30px',
            marginTop: '30px',
            fontStyle: 'italic'
          }}>
            Questions? Visit our LiChess FAQ for more details.
          </div>

          {/* Separator line */}
          <div style={{
            width: '100%',
            height: '1px',
            backgroundColor: '#333',
            marginBottom: '20px'
          }}></div>

          {/* Footer */}
          <div style={{
            cursor: 'pointer',
            textAlign: 'center',
            color: 'gray',
            fontSize: 'clamp(14px, 1.5vw, 16px)',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}>
            <img
              src={LichessLogo}
              alt="Lichess Logo"
              style={{
                width: 24,
                height: 24
              }}
              onClick={() => window.open('https://lichess.org', '_blank')}
            />
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => window.open('https://lichess.org', '_blank')}
            >
              POWERED BY LICHESS.ORG
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container" style={{
    }}>
      <div className="explore-container main-column" style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        width: '100%',
        justifyContent: 'space-around',
        scrollbarWidth: 'none',
        background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
      }}>
        <div style={{
          fontSize: '40px',
          fontWeight: 'bold',
          textAlign: 'center',
          borderBottom: '2px solid gold',
          paddingBottom: '10px',
          color: 'gold',
        }}>
          P L A Y&nbsp;&nbsp;&nbsp;&nbsp;C H E S S
        </div>
        {/* Tab Navigation */}
        <div className="tab-navigation" style={{
          width: '100%'
        }}>

          <div style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'space-between'
          }}>
            <button
              onClick={() => handleTabChange('Random Opponent')}
              style={activeTab === 'Random Opponent' ? activeButtonStyle : buttonBaseStyle}
            >
              Public
            </button>
            <button
              onClick={() => handleTabChange('Friends')}
              style={activeTab === 'Friends' ? activeButtonStyle : buttonBaseStyle}
            >
              Friends
            </button>
            <button
              onClick={() => handleTabChange('Bot')}
              style={activeTab === 'Bot' ? activeButtonStyle : buttonBaseStyle}
            >
              Engine
            </button>
          </div>

        </div>

        {/* Conditional Tab Content */}
        {activeTab === 'Random Opponent' && renderPublicContent()}
        {activeTab === 'Friends' && renderFriendsContent()}
        {activeTab === 'Bot' && renderEngineContent()}

        <div style={{ cursor: 'pointer', textAlign: 'center', color: 'gray', borderTop: '2px solid gray', fontSize: '20px', fontWeight: 'bold', paddingTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img src={LichessLogo} alt="Lichess Logo" style={{ width: 30, height: 30, tintColor: 'red' }} onClick={() => window.open('https://lichess.org', '_blank')} />
          <span style={{ cursor: 'pointer' }} onClick={() => window.open('https://lichess.org', '_blank')}>POWERED BY LICHESS.ORG</span>
        </div>

        {/* Footer */}

      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  game: state.game,
  isConnectedToLichess: state.user.lichessConnected,
});

export default connect(mapStateToProps, { connectToEventStream })(Play);
